// hooks/usePackageStateLabel.js

import { PACKAGE_STATES } from "../transformers/searchDataTransformer";

const usePackageStateLabel = (businessPartnerId) => {
  const hasIntegration = businessPartnerId != null;

  const labels = hasIntegration
    ? PACKAGE_STATES.with_integration
    : PACKAGE_STATES.without_integration;

  const getLabel = (stateCode) => labels[stateCode] ?? "Unknown";

  return { getLabel, labels, hasIntegration };
};

export default usePackageStateLabel;
